import { FunctionDocs } from "components/docs";
import { ComponentExample } from "components/examples";

const UseDebouncedState = () => (
  <FunctionDocs entry="useDebouncedState">
    <ComponentExample
      name="Debounced Update"
      import={import(
        "examples/Utility/UseDebouncedState/DebouncedStateExample"
      )}
      rawImport={import(
        "examples/Utility/UseDebouncedState/DebouncedStateExample?raw"
      )}
    />
  </FunctionDocs>
);

export default UseDebouncedState;
